import type { LoadBid } from '@numeo/types'
import { HandCoins } from 'lucide-react'
import { bidLoadId, bidderLabel, fmtBidPrice } from '../utils/bidFormat'
import type { LoadLaneFields } from '../utils/format'
import { loadLaneLabel } from '../utils/format'

interface BidNotificationCardHeadProps {
    bid: LoadBid
    load?: LoadLaneFields
    prevPrice?: number
}

/** Compact content shared by the collapsed and expanded driver-bid notification cards. */
export const BidNotificationCardHead = ({ bid, load, prevPrice }: BidNotificationCardHeadProps) => {
    const lane = loadLaneLabel(load)

    return (
        <div className="flex items-start gap-3 p-3">
            <div className="mt-0.5 flex size-9 shrink-0 items-center justify-center rounded-full bg-success-soft text-success-soft-foreground">
                <HandCoins size={18} />
            </div>
            <div className="min-w-0 flex-1">
                <div className="truncate text-base font-bold text-foreground">{bidderLabel(bid, 'A driver')}</div>
                <div className="mt-0.5 flex items-center gap-1.5 text-xs">
                    <span className="font-semibold text-foreground-muted">{prevPrice != null ? 'Updated bid' : 'New bid'}</span>
                    {prevPrice != null && (
                        <>
                            <span className="text-foreground-muted line-through">{fmtBidPrice(prevPrice, bid.currency)}</span>
                            <span className="text-foreground-muted">→</span>
                        </>
                    )}
                    <span className="font-bold text-success">{fmtBidPrice(bid.price, bid.currency)}</span>
                    <span className="truncate text-foreground-muted">· #{bidLoadId(bid)}</span>
                </div>
                {lane && (
                    <div className="mt-1 truncate text-xs text-foreground-muted" title={lane}>
                        {lane}
                    </div>
                )}
            </div>
        </div>
    )
}
